import { render, staticRenderFns } from "./VStatisticalCard.vue?vue&type=template&id=40b20cb4"
import script from "./VStatisticalCard.vue?vue&type=script&lang=js"
export * from "./VStatisticalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports